import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.snowflakeGetQuery;

const snowflakeGetQueryData = createSelector([selector], (state) => state);

export default {
  snowflakeGetQueryData
};